import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <nav className='navbar'>
      <div className='navbar-container'>
        <Link to='/' className='navbar-logo'>
          Money Minded Apes
        </Link>

        <div className='navbar-menu'>
          <Link to='/' className='navbar-item navbar-home'>
            Home
          </Link>

          <div className='navbar-dropdown' ref={dropdownRef}>
            <button className='navbar-item dropdown-toggle' onClick={toggleDropdown}>
              Collections
              <span className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`}>▼</span>
            </button>

            {isDropdownOpen && (
              <div className='dropdown-menu'>
                <Link to='/og-apes' className='dropdown-item' onClick={closeDropdown}>
                  OG Money Minded Apes
                </Link>
                <Link to='/private-jet-apes' className='dropdown-item' onClick={closeDropdown}>
                  Private Jet Apes
                </Link>
                <Link to='/xwar-apes' className='dropdown-item' onClick={closeDropdown}>
                  X War Meta Apes
                </Link>
                <Link to='/top-g-apes' className='dropdown-item' onClick={closeDropdown}>
                  Top G Apes
                </Link>
                <Link to='/mutants' className='dropdown-item' onClick={closeDropdown}>
                  Money Minded Mutants
                </Link>
                <Link to='/pixel-apes' className='dropdown-item' onClick={closeDropdown}>
                  Money Minded Pixel Apes
                </Link>
                <Link to='/mula-trees' className='dropdown-item' onClick={closeDropdown}>
                  Money Minded Mula Trees
                </Link>
                <Link to='/ladies' className='dropdown-item' onClick={closeDropdown}>
                  Money Minded Ladies
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
